// 프로덕션: /api → Railway 등 백엔드로 보내기 (가장 먼저 실행)
import './config/installApiBase';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { setupGlobalErrorHandler } from './utils/globalErrorHandler';
import { devLog } from './utils/devLog';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ 전역 에러 핸들러 설정 (가장 먼저 실행)
// 모듈 로딩 단계에서 발생하는 동기 에러를 포착하기 위해
// 모든 import 이후, React 앱 초기화 전에 설정합니다.
devLog('[index.js] 🚀 모듈 로딩 시작');
setupGlobalErrorHandler();
devLog('[index.js] ✅ 전역 에러 핸들러 설정 완료');

try {
  devLog('[index.js] 📦 App 모듈 import 완료');

  const root = ReactDOM.createRoot(document.getElementById('root'));
  devLog('[index.js] ✅ React root 생성 완료');

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  devLog('[index.js] ✅ React 앱 렌더링 시작');
} catch (error) {
  console.error('[index.js] ❌ 앱 초기화 실패:', error);
  // setupGlobalErrorHandler가 이미 설정되어 있으므로 에러가 자동으로 표시됨
  // 에러를 다시 throw하여 전역 핸들러가 포착하도록 함
  throw error;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
